<template>
    <div class="rightSideBar expand animated fadeInRight logDetailsPanelMainContainer">
        <div class="incomingMsgEditContainer apiLogItemsMainContainer">
            <div class="apiLogItemContainer1">
                <span class="apiLogItemHeading">Log ID</span><br/>
                <h5 class="apiLogItemValue">{{ incomingMessageDetailsData.LogID ? incomingMessageDetailsData.LogID : '' }}</h5>
            </div>
            <div class="apiLogItemContainer2">
                <span class="apiLogItemHeading">Resource path</span><br/>
                <h5 class="apiLogItemValue">{{ incomingMessageDetailsData.ResourcePath ? incomingMessageDetailsData.ResourcePath : '' }}</h5>
            </div>
            <div class="apiLogItemContainer3">
                <span class="apiLogItemHeading">Method</span><br/>
                <h5 class="apiLogItemValue">{{ incomingMessageDetailsData.ReqMethod ? incomingMessageDetailsData.ReqMethod : ''}}</h5>
            </div>
            <div class="apiLogItemContainer1">
                <span class="apiLogItemHeading">IP Address</span><br/>
                <h5 class="apiLogItemValue">{{ incomingMessageDetailsData.ReqOriginIP ? incomingMessageDetailsData.ReqOriginIP : ''}}</h5>
            </div>
            <div class="apiLogItemContainer2">
                <span class="apiLogItemHeading">Integration Name</span><br/>
                <span class="integrationCard" >
                    <span class="ApiCard ApiCardHeightAdjustment" :class="incomingMessageDetailsData.IntegrationName">
                        <span class="integrationLogo logoAlignment"></span>
                    </span>
                </span>
                <!-- <h5 class="apiLogItemValue">{{ incomingMessageDetailsData.IntegrationName ? incomingMessageDetailsData.IntegrationName : '' }}</h5> -->
            </div>
            <div class="apiLogItemContainer3">
                <span class="apiLogItemHeading">Integration ID</span><br/>
                <h5 class="apiLogItemValue">{{ incomingMessageDetailsData.IntegrationId ? incomingMessageDetailsData.IntegrationId : '' }}</h5>
            </div>
            <div class="apiLogItemContainer2">
                <span class="apiLogItemHeading">Timestamp</span><br/>
                <h5 class="apiLogItemValue">{{ incomingMessageDetailsData.CreatedDate ? formatDate(incomingMessageDetailsData.CreatedDate) : "" }}</h5>
            </div>
        </div>
        
        <div class="logDetailContinerHeading" @click="toggleSection('req')">
            <h5 class="mt-3">
                <i :class="showReqBody ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" class="mr-2 ml-3"></i>
                Request
            </h5>
        </div>
        <div class="incomingMsgEditContainer reqBodyContainer" v-show="showReqBody">
            <h6>Request Body:</h6>
            <div class="copyButtonFixedContainer">
                <div class="openApiBodyContainer">
                    <tree-view :data="parsedReqBody" :options="{maxDepth: 10}"></tree-view>
                </div>
                <button v-show="incomingMessageDetailsData.ReqBody != null" @click="copyJsonToClipboard(incomingMessageDetailsData.ReqBody)" class="reqBodyCopyButton" title="copy to clipboard">
                    <span v-show="copyClicked" class="copiedTextStyle">copied</span>
                    <i v-show="!copyClicked" class="fa fa-clone" aria-hidden="true"></i>
                    <i v-show="copyClicked" class="fa fa-check" aria-hidden="true"></i>
                </button>
            </div> 
        </div>
        <div class="logDetailContinerHeading" @click="toggleSection('res')">
            <h5 class="mt-3">
                <i :class="showResBody ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" class="mr-2 ml-3"></i>
                Response
            </h5>
        </div>
        <div class="incomingMsgEditContainer reqBodyContainer" v-show="showResBody">
            <h6>Status: <span class="openApiValues">{{ incomingMessageDetailsData.ResStatusCode ? incomingMessageDetailsData.ResStatusCode : "" }}</span></h6>  
            <h6>Response Body:</h6>
            <div class="copyButtonFixedContainer">
                <div class="openApiBodyContainer">
                    <tree-view :data="parsedResBody" :options="{maxDepth: 10}"></tree-view>
                </div>
                <button v-show="incomingMessageDetailsData.ResBody != null" @click="copyJsonToClipboard(incomingMessageDetailsData.ResBody)" class="reqBodyCopyButton" title="copy to clipboard">
                    <span v-show="copyClicked" class="copiedTextStyle">copied</span>
                    <i v-show="!copyClicked" class="fa fa-clone" aria-hidden="true"></i>
                    <i v-show="copyClicked" class="fa fa-check" aria-hidden="true"></i>
                </button>
            </div> 
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import TreeView from "vue-json-tree-view";
import moment from 'moment-timezone';
Vue.use(TreeView);

export default {
    name: 'incomingMessageDetails',
    props: ['incomingMessageDetailsData'],
    data() {
        return {
            showReqBody: true,
            showResBody: false,
            copyClicked:false
        };
    },
    methods: {
        toggleSection(section) {
            if (section === 'req') {
                this.showReqBody = true;
                this.showResBody = false;
            } else {
                this.showReqBody = false;
                this.showResBody = true;
            }
        },
        copyJsonToClipboard(data) {
            // const jsonStr = JSON.stringify(data, null, 2); // Format JSON with indentation
            navigator.clipboard.writeText(data).then(() => {
                // alert('JSON copied to clipboard');
                this.copyClicked=true;
                setTimeout(() => {
                    this.copyClicked=false;
                }, 1000);
            }).catch(err => {
                console.log('Failed to copy JSON:', err);
            });
        },
        formatDate(isoDate) {
            if (!isoDate) return '';
            return moment.utc(isoDate).format('MMMM Do YYYY, h:mm:ss A');
        }
    },
    computed: {
        parsedReqBody() {
            try {
                if (this.incomingMessageDetailsData.ReqBody && typeof this.incomingMessageDetailsData.ReqBody === 'string') {
                    return JSON.parse(this.incomingMessageDetailsData.ReqBody);
                } else {
                    return 'ReqBody is empty or not a valid string.';  
                }
            } catch (error) {
                return 'Invalid JSON:';  
            }
        },
        parsedResBody() {
            try {
                if (this.incomingMessageDetailsData.ResBody && typeof this.incomingMessageDetailsData.ResBody === 'string') {
                    return JSON.parse(this.incomingMessageDetailsData.ResBody);
                } else {
                    return this.incomingMessageDetailsData.ResBody;  
                }
            } catch (error) {
                return this.incomingMessageDetailsData.ResBody;  
            }
        }
    },
    mounted() {
        console.log("incomingMessageDetailsData", this.incomingMessageDetailsData)
    },
};
</script>
<style scoped>
.copyButtonFixedContainer{
    position: relative;
}
.logDetailContinerHeading{
    height:40px;
    border-bottom:#cccccc solid 1px;
    /* line-height: 60px; */
    cursor: pointer;
}
.logDetailsPanelMainContainer{
    width: 630px;
    z-index: 9999;
    overflow: scroll;
    padding: 10px;
    font-family: 'Roboto';
    color: black;
}
.openApiBodyContainer{
    padding: 20px;
    background-color: #ebeef5;
    color: black;
    border-radius: 10px;
    max-height: 40vh;
    overflow: auto;
}
.openApiValues{
    font-weight: normal;
}
.reqBodyCopyButton{
    background-color: #ebeef5;
    color: black;
    padding: 0px;
    border: 0px;
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 15px;
}
.reqBodyCopyButton:focus{
    outline: none;
    box-shadow: none;
}
.reqbodyCopyFlexContainer{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.reqBodyContainer{
    background: white;
    /* overflow: scroll; */
}
.copiedTextStyle{
    font-size: 14px;
    margin-right: 3px;
}
.apiLogItemHeading{
    font-size: 13px;
    color: gray;
}
.apiLogItemValue{
    font-size: 16px;
    font-weight: 600;
}
.apiLogItemContainer1{
    width: 28%;
    /* background-color:aqua; */
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 10px;
}
.apiLogItemContainer2{
    width: 40%;
    /* background-color:aqua; */
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 10px;
    flex-grow: 1;
}
.apiLogItemContainer3{
    width: 28%;
    /* background-color:aqua; */
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 15px;
}
.apiLogItemsMainContainer{
    display: flex;
    flex-wrap: wrap;
    background-color: #ebeef5;
    border-radius: 10px;
}
.ApiCardHeightAdjustment{
    height: unset;
    width: unset;
    border: none;
}
.logoAlignment{
    background-position: left !important;
    margin-top: 2px !important;
    height: 20px !important;
    background-size: contain !important;
}
</style>